module.exports = __webpack_public_path__ + "media/images/completed-18e24ccfb5a88a0685f521d90ef2e232.gif";